import { UserData } from '../../models/UserData';

export class AddUserData {
  static readonly type = '[UserData] add';
  constructor(public payload: UserData) {}
}

export class RemoveUserData {
  static readonly type = '[UserData] remove';
  constructor() {
    /**/
  }
}
